import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruth18getGetScreenTruthGrantsResponseSchema = jsonObject
export type tcpscreentruth18getGetScreenTruthGrantsResponse = z.infer<typeof tcpscreentruth18getGetScreenTruthGrantsResponseSchema>
